function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: c , size: l = 24  } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), t = c !== null && c !== void 0 ? c : e ? a.colors.inverse : a.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M19.12 7.53a.88.88 0 01.26.622V20.46a1.4 1.4 0 01-1.384 1.381H5.999c-.737 0-1.384-.644-1.384-1.38V3.535c0-.723.658-1.381 1.384-1.381H13.3c.227 0 .44.087.603.247l5.215 5.128zm-.93 12.93V9.02h-2.28c-.998 0-1.86-.327-2.494-.952-.639-.63-.975-1.487-.975-2.479V3.365H6c-.073 0-.19.112-.196.171V20.46c0 .06.1.171.196.171h11.997c.098 0 .193-.098.193-.17zM13.625 3.813v1.773c0 .659.213 1.216.617 1.611.406.4.983.61 1.666.61 0 .003 1.782.003 1.782.003l-4.065-3.997zm-5.89 8.807a.61.61 0 00.002.86.59.59 0 00.835-.006l.779-.792.778.792.009.009a.588.588 0 00.832-.009.61.61 0 000-.854l-.779-.793.779-.793a.61.61 0 000-.854l-.009-.008a.585.585 0 00-.829.008l-.778.793-.78-.793-.01-.011a.585.585 0 00-.83.011.61.61 0 000 .854l.78.793-.78.793zm8.655-2.443a.61.61 0 010 .855l-.779.793.779.792a.61.61 0 010 .854.588.588 0 01-.832.009l-.008-.008-.78-.793-.778.793a.59.59 0 01-.835.005l-.005-.005a.61.61 0 010-.855l.779-.793-.78-.792a.61.61 0 010-.855.585.585 0 01.83-.01l.011.01.779.793.779-.793a.585.585 0 01.829-.01l.011.01zm-.317 6.69c0-1.233-.865-1.805-1.725-1.824l-.129.003c-.854.005-1.72.568-1.72 1.829 0 .18 0 .602-.549.605h-.087c-.563-.014-.563-.434-.563-.614 0-1.232-.865-1.803-1.725-1.823h-.129c-.86.006-1.723.569-1.723 1.815a.6.6 0 00.594.605.6.6 0 00.594-.605c0-.18 0-.602.549-.605h.087c.563.014.563.434.563.613 0 1.23.865 1.799 1.725 1.821h.132c.854-.005 1.72-.569 1.72-1.829 0-.18 0-.602.549-.605h.087c.563.014.563.434.563.613a.6.6 0 00.594.605.6.6 0 00.593-.605z"
        })
    }));
}, v = i;
export { v as default };
